import AppearanceAccordion from '../3modules/Config/AppearanceAccordion'
import useAppearanceConfiguration from '../../services/configPage/useAppearanceConfiguration'
import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'

const AppearanceConfiguration = () => {
    const {onEditMode, setOnEditMode, isSnackbarOpen, setIsSnackbarOpen, isLoading, setIsLoading} = useConfiguration()
    const {handleSave, selectedIcons, setSelectedIcons, selectedFontStyle,
        setSelectedFontStyle, selectedColors, setSelectedColors, colorOptions, fontStyleOptions, iconsOptions,
        resetToDefault, handlePreview, handleCancel} = useAppearanceConfiguration(onEditMode, setOnEditMode, isSnackbarOpen, setIsSnackbarOpen, isLoading, setIsLoading)

    return (
        <ConfigurationWrapper isLoading={isLoading} handleCancel={handleCancel} handlePreview={handlePreview}
                              handleSave={handleSave} onEditMode={onEditMode} setOnEditMode={setOnEditMode}
                              isSnackbarOpen={isSnackbarOpen} setIsSnackbarOpen={setIsSnackbarOpen}
                              resetToDefault={resetToDefault} header={'Appearance Configuration'}
        >
            <AppearanceAccordion label={'Colors'} optionList={colorOptions} onEditMode={onEditMode} value={selectedColors} handleChange={setSelectedColors} />
            <AppearanceAccordion label={'Font Style'} optionList={fontStyleOptions} onEditMode={onEditMode} value={selectedFontStyle} handleChange={setSelectedFontStyle} />
            <AppearanceAccordion label={'Icons'} optionList={iconsOptions} onEditMode={onEditMode} value={selectedIcons} handleChange={setSelectedIcons} />
        </ConfigurationWrapper>

    )
}

export default AppearanceConfiguration
